import { buildActivityToSkills } from './skill-graph';

// Activates the skill-graph DAG by populating skillGraph.activityToSkills —
// which is declared empty and was never built, leaving getNextActivities /
// getSkillPath / getUnlockedActivities as dead code. Once populated,
// prerequisite-aware sequencing and per-node skill paths come alive.
//
// The heavy raw-activity JSON (~3.8 MB) lives behind a dynamic import so it
// never enters the entry chunk; activation runs once, after first paint, off
// the hot path (see App.tsx). Nothing reads activityToSkills synchronously
// during first paint, so deferring is safe.

let activated = false;

export async function ensureSkillGraphActivated(): Promise<void> {
  if (activated) return;
  activated = true;
  try {
    const { ALL_RAW_ACTIVITIES } = await import('./raw-activities');
    buildActivityToSkills(ALL_RAW_ACTIVITIES);
  } catch {
    // Allow a later retry if the lazy chunk failed to load (offline first run).
    activated = false;
  }
}

/** Test/inspection helper — has the DAG been built this session? */
export function isSkillGraphActivated(): boolean {
  return activated;
}
